import React from "react";
import {useEffect} from "react";
import { MDXProvider } from "@mdx-js/react";
import * as components from "./mdx-components";
import MDXRenderer from "./mdx-components/mdx-renderer";
import ReferencesBlock from "./references-block";
import { LinkToStacked } from "react-stacked-pages-hook";
import Comment from "./comment";

const Note = (data) => {
  const AnchorTag = (props) => (
    <components.a {...props} references={data.outboundReferences} />
  );

  const commentBox = React.createRef();

  useEffect(() => {
      const scriptEl = document.createElement('script');
      scriptEl.async = true;
      scriptEl.src = 'https://utteranc.es/client.js';
      scriptEl.setAttribute('repo', 'paulbricman/hypothesis-subspace');
      scriptEl.setAttribute('issue-term', data.title);
      scriptEl.setAttribute('id', 'utterances');
      scriptEl.setAttribute('theme', 'github-light');
      scriptEl.setAttribute('crossorigin', 'anonymous');
      if (commentBox && commentBox.current) {
          commentBox.current.appendChild(scriptEl);
      } else {
          console.log(`Error adding utterances comments on: ${commentBox}`);
      }
  }, []);

  return (
    <React.Fragment>
      {data.partOf ? (
        <div>
          Part of{" "}
          <LinkToStacked to={data.partOf.slug}>
            {data.partOf.title}
          </LinkToStacked>
        </div>
      ) : null}
      <MDXProvider components={{ ...components, a: AnchorTag }}>
        <MDXRenderer>{data.mdx}</MDXRenderer>
      </MDXProvider>
          <div style={{marginTop: '3em', paddingTop: '2em', borderTop: '2px dashed var(--separator)'}}>
      <Comment commentBox={commentBox}/>
          </div>
    </React.Fragment>
  );
};

export default Note;
